import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import React from 'react';
import ReactDOM from 'react-dom';
import { createBrowserHistory, LocationState } from 'history';
import { Route } from 'react-router-dom';
import { ConnectedRouter as Router } from 'connected-react-router';
import { LoggerHelper, ErrorBoundary } from 'ff-shared-components-core';
import 'semantic-ui-css/semantic.min.css';
import 'bootstrap/dist/css/bootstrap.css';
// import './assets/styles/main.less';
import './index.less';
import { App } from './App';
import { ApiClientManager } from '@api/ff-shared-services-api';
import { ApiConfig } from './config';
import configureStore from './configureStore';
import { LoggerConfig } from '@config';
import { UnexpectedError } from '@shared/components';
import { Provider } from 'react-redux';

const history = createBrowserHistory<LocationState>();

export const startCustomerJourney = (authInfoPassed: string): void => {
	if (authInfoPassed) {
		const { store } = configureStore(history);

		/* Init API fetch client */
		ApiClientManager.init(
			ApiConfig.url,
			{
				'content-type': ApiConfig.headers['content-type'],
				'X-Lang': 'pt',
			},
			store,
			LoggerConfig.log
		);

		ReactDOM.render(
			<div id="ff-reg" className="ff-reg">
				<Provider store={store}>
					<Router history={history}>
						<Route
							render={({ location }): React.ReactNode => (
								<ErrorBoundary
									containerErrorMessage={(error): React.ReactNode => (
										<UnexpectedError error={error} />
									)}
								>
									<App />
								</ErrorBoundary>
							)}
						/>
					</Router>
				</Provider>
			</div>,
			document.getElementById('root')
		);
	} else {
		ReactDOM.render(<span>Session Info not found...</span>, document.getElementById('root'));
	}
};

const mockedAuthInfo = {
	accessToken: '',
	expirationDate: '',
	interaction: {
		id: 0,
	},
	refreshToken: '',
	user: {
		customer: {
			entity: {
				id: 0,
				name: '',
				type: '',
			},
			id: 0,
		},
		entity: {
			id: 0,
			name: '',
			type: '',
		},
		id: 0,
	},
	language: 'PT',
	isAuthenticated: false,
	permissions: [],
};

startCustomerJourney(JSON.stringify(mockedAuthInfo));

// eslint-disable-next-line @typescript-eslint/no-explicit-any
(window as any).startCustomerJourney = startCustomerJourney;
